var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"talent-link",attrs:{"href":_vm.talentUrl,"target":_vm.target}},[_vm._t("default"),_c('v-icon',{staticClass:"icon"},[_vm._v("mdi-open-in-new")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }